import React from 'react';
import { I18n } from '@aws-amplify/core';
import { Col, Input } from 'antd';
import FormItem from '@/components/ui/FormItem';

interface WorkCenterProps {
	onValueChange: (changed: boolean) => void;
}

export const WorkCenter: React.FC<WorkCenterProps> = ({ onValueChange }) => {
	return (
		<Col xs={24} sm={12}>
			<FormItem labelCol={{ span: 24 }} name={['work_center']} label="Work center">
				<Input
					size="large"
					placeholder={I18n.get('Work center')}
					onChange={() => onValueChange(true)}
				/>
			</FormItem>
		</Col>
	);
};
